import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ORDERER_URL = `${BACKEND_URL}/api/setting/orderer-routing-rules`;
const WAREHOUSE_URL = `${BACKEND_URL}/api/setting/warehouse-routing-rules`;

const getOrdererRules = () => axios.get(ORDERER_URL);
const createOrdererRule = (data) => axios.post(ORDERER_URL, data);
const updateOrdererRule = (id, data) => axios.put(`${ORDERER_URL}/${id}`, data);
const deleteOrdererRule = (id) => axios.delete(`${ORDERER_URL}/${id}`);

const getWarehouseRules = () => axios.get(WAREHOUSE_URL);
const createWarehouseRule = (data) => axios.post(WAREHOUSE_URL, data);
const updateWarehouseRule = (id, data) => axios.put(`${WAREHOUSE_URL}/${id}`, data);
const deleteWarehouseRule = (id) => axios.delete(`${WAREHOUSE_URL}/${id}`);

export default {
  getOrdererRules,
  createOrdererRule,
  updateOrdererRule,
  deleteOrdererRule,
  getWarehouseRules,
  createWarehouseRule,
  updateWarehouseRule,
  deleteWarehouseRule,
};
